import { Component, computed, inject, input } from '@angular/core';
import { SupplierContractStore } from '../../stores/supplier-contracts.store';
import { Router, RouterLink, RouterOutlet } from '@angular/router';
import { OrganizationSidebarLayout } from '../../../organizations/components/organization-sidebar-layout/organization-sidebar-layout';
import { PageHeader } from '../../../layout/components/page-header/page-header';
import { Button, Skeleton } from 'excellence-ui';
import { NgIcon } from '@ng-icons/core';
import { PageTitle } from '../../../layout/components/page-title/page-title';
import { ErrorPage } from '../../../../shared/components/error-page/error-page';
import { SupplierContractsDetailsBreadcrumbNav } from '../../components/supplier-contracts-details-breadcrumb-nav/supplier-contracts-details-breadcrumb-nav';
import { SupplierContractsDetailsNav } from '../../components/supplier-contracts-details-nav/supplier-contracts-details-nav';
import { TranslocoPipe } from '@jsverse/transloco';

@Component({
  imports: [
    OrganizationSidebarLayout,
    PageHeader,
    Button,
    RouterLink,
    NgIcon,
    PageTitle,
    RouterOutlet,
    ErrorPage,
    SupplierContractsDetailsBreadcrumbNav,
    SupplierContractsDetailsNav,
    Skeleton,
    TranslocoPipe,
  ],
  templateUrl: './supplier-contracts-details-page.html',
})
export class SupplierContractsDetailsPage {
  private store = inject(SupplierContractStore);
  protected router = inject(Router);

  organizationId = input.required<string>();
  supplierContractId = input.required<string>();

  state = computed(() => this.store.getSingleEntry(this.supplierContractId()));
}
